import {environment} from '@/commons/configs/Config';
import Cookies from "js-cookie";

export async function addComment(content, postId) {
    let token = Cookies.get(environment.accessToken);
    let data = {
        "content": content,
        "postId": postId
    }
    const result = fetch(environment.apiUrlOne + '/comment/create', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token
        },
        body: JSON.stringify(data),
    });

    return await result;
}

export async function editCategory(postId, categoryId, text) {
    let token = Cookies.get(environment.accessToken);
    let data = {
        "text": text
    }
    const result = fetch(environment.apiUrlOne + '/posts/editCategory/' + postId + '/' + categoryId, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token
        },
        body: JSON.stringify(data),
    });

    return await result;
}

export async function getLightUserPosts(userId, page, items) {
    let token = Cookies.get(environment.accessToken);
    let data = {
        "page": page,
        "items": items
    }
    const result = fetch(environment.apiUrlTwo + '/posts/getUserPosts/' + userId, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token
        },
        body: JSON.stringify(data),
    });

    return await result;
}

export async function getImage(imageUid) {
    const result = fetch(environment.apiUrlOne + '/images/get/' + imageUid, {
        method: 'GET'
    });
    return await result;
}

export async function getLastStaffComment(reportID){
    let token = Cookies.get(environment.accessToken);
    const result = await fetch(environment.apiUrlTwo + '/posts/lastResponse/staff/' + reportID, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token
        }
    });
    if(result.status === 200){
        return await result.json();
    }else{
        return null;
    }
}
export async function getLastUserComment(reportID){
    let token = Cookies.get(environment.accessToken);
    const result = await fetch(environment.apiUrlTwo + '/posts/lastResponse/user/' + reportID, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token
        }
    });
    if(result.status === 200){
        return await result.json();
    }else{
        return null;
    }
}